import React from 'react';

import styles from './FooterDark.scss';
import lockImg from './img/lock.png';
import {__t} from '../../common/lang/text-resource';

const FooterDark = ({profileURL}) => {

	const lang = SHVO.pageLang ?? 'bg';

	if (!profileURL) {
		return null;
	}
	return (
	  <section className={styles.container}>
		  <div className={styles.innerContainer} data-layout="row start around">
			  <section data-layout="col 12 4@sm 3@md 2@tb">
				  <div className={styles.colTitle}>{__t("Нашите услуги")}</div>
				  <ul>
					  <li>
						  <a href="/web-hosting-compare-hosting-plans.php"
							 title={__t("Хостинг планове")}>{__t("Хостинг планове")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-register-domains.php"
							 title={__t("Домейн имена")}>{__t("Домейн имена")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-certificates.php"
							 title={__t("SSL Сертификати")}>{__t("SSL Сертификати")}</a>
					  </li>
					  <li>
						  <a href="/wp-hosting.php" title={__t("WordPress хостинг")}>{__t("WordPress хостинг")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-common-managed-vps.php"
							 title={__t("Managed VPS")}>{__t("Managed VPS")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-servers-vps.php"
							 title={__t("Виртуални сървъри")}>{__t("Виртуални сървъри")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-servers-dedicated.php"
							 title={__t("Наети сървъри")}>{__t("Наети сървъри")}</a>
					  </li>
					  {/*https://jira.superhosting.bg/browse/MARKETING-73*/}
					  {/*
						<li>
							<a href="/google-adwords.htm" title="Реклама с Google Ads ™">Реклама с Google Ads™</a>
						</li>
						*/}
					  <li>
						  <a href="/web-hosting-page-search-registration.php"
							 title={__t("Популяризация в уеб")}>{__t("Популяризация в уеб")}</a>
					  </li>
				  </ul>
			  </section>
			  <section data-layout="col 12 4@sm 3@md  2@tb">
				  <div className={styles.colTitle}>{__t("Новини и промоции")}</div>
				  <ul>
					  {/*<li>*/}
					  {/*	<a href="/web-hosting-page-promotions.php" title={__t("Промоции")}>{__t("Промоции")}</a>*/}
					  {/*</li>*/}
					  <li>
						  <a
							href={`https://blog.superhosting.bg/${lang === 'en' ? 'en/' : ''}category/superhosting-news`}
							title={__t("Новини и събития")}>{__t("Новини и събития")}</a>
					  </li>
					  <li>
						  <a
							href={`https://blog.superhosting.bg/${lang === 'en' ? 'en/' : ''}category/superhosting-tips-of-support`}
							title={__t("Полезни съвети")}>{__t("Полезни съвети")}</a>
					  </li>
					  <li>
						  <a
							href={`https://help.superhosting.bg/${lang === 'en' ? 'en/' : ''}`}
							target="_blank"
							rel="noopener noreferrer"
							title={__t("Статии")}>{__t("Статии")}</a>
					  </li>
				  </ul>
			  </section>
			  <section data-layout="col 12 4@sm 3@md  2@tb">
				  <div className={styles.colTitle}>{__t("За СуперХостинг.БГ")}</div>
				  <ul>
					  <li>
						  <a href="/web-hosting-page-about-company.php"
							 title={__t("За компанията")}>{__t("За компанията")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-about-company.php"
							 title={__t("Защо SuperHosting.BG?")}>{__t("Защо да изберете нашите услуги")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-about-company.php#testimonials"
							 title={__t("Клиентите за нас")}>{__t("Клиентите за нас")}</a>
					  </li>
					  {lang === 'bg' && <li>
						  <a href="/super-partners#small-videos-container"
							 title={__t("Нашите партньори")}>{__t("Нашите партньори")}</a>
					  </li>}
					  <li>
						  <a href="/web-hosting-page-contact.php" title={__t("За Контакти")}>{__t("За Контакти")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-careers.php" title={__t("Кариери")}>{__t("Кариери")}</a>
					  </li>
					  <li>
						  <a href="/web-hosting-page-dsa-annual-report.php" title={__t("Годишен отчет (ЗДУ)")}>{__t("Годишен отчет (ЗДУ)")}</a>
					  </li>
				  </ul>
			  </section>
			  <section data-layout="col 12 4@sm 3@md  2@tb">
				  <div className={styles.colTitle}>{__t("Клиентски профил")}</div>
				  <ul>
					  <li>
						  <a
							href={profileURL + 'web-hosting-client-profile.php'}
							title={__t("Вход в клиентския профил")}>
							  <img src={lockImg} alt={__t("Клиентски профил")} data-layout="margin-right--xs"/>
							  {__t("Вход в профила")}
						  </a>
					  </li>
					  <li>
						  <a
							href={profileURL + 'web-hosting-client-hosting.php'}
							title={__t('управление-на-вашите-хостинг-акаунти-в-клиентския242fb5')}>
							  <img src={lockImg} alt={__t("Клиентски профил")} data-layout="margin-right--xs"/>
							  {__t("Хостинг акаунти")}
						  </a>
					  </li>
					  <li>
						  <a
							href={profileURL + 'web-hosting-client-domain-edit-list.php'}
							title="Управление на вашите домейни в клиентския профил">
							  <img src={lockImg} alt="Клиентски профил" data-layout="margin-right--xs"/>
							  {__t("Управление на домейни")}
						  </a>
					  </li>
					  <li>
						  <a
							href={profileURL + 'web-hosting-client-renew-services.php'}
							title={__t("Подновяване на услуги")}>
							  <img src={lockImg} alt={__t("Клиентски профил")} data-layout="margin-right--xs"/>
							  {__t("Подновяване на услуги")}
						  </a>
					  </li>
					  {/*<li>*/}
					  {/*	<a*/}
					  {/*		href={profileURL + 'web-hosting-client-balance.php'}*/}
					  {/*		title="Захранване на сметка">*/}
					  {/*		<img src={lockImg} alt="Клиентски профил" data-layout="margin-right--xs"/>*/}
					  {/*		Захранване на сметка*/}
					  {/*	</a>*/}
					  {/*</li>*/}
				  </ul>
			  </section>
		  </div>
		  <div>
			  {__t('всички-права-запазени-©-2005-date-за-суперхостинг6f9ad2', {date: new Date().getFullYear()})}&nbsp;
			  <a
				href="/web-hosting-page-terms-and-agreements.php">{__t('общите условия')}</a> {SHVO.pageLang == 'bg' && __t('за ползване.')}
		  </div>
		  <div>
			  {__t('суперхостинг-бг-пази-вашите-лични-данни-в-съответbff9d7')}
			  <br/>
			  {__t("Вижте повече в")} <a
			href="/web-hosting-page-privacy-policy.php">{__t('задължителната-информация-за-правата-на-лицата-по9357a3')}</a>

		  </div>
		  <div>
			  {__t('при-възникване-на-спор-който-не-може-да-бъде-реше4c119f')}&nbsp;
			  <a href="https://ec.europa.eu/consumers/odr">{__t('ОРС')}</a>.
		  </div>
		  <div className={styles.taa}>
			  <div>
				  {/*{__t('-посочената-цена-е-валидна-при-поръчки-за-нови-ус58011e')}*/}
				  <br/>
				  {SHVO.pageLang == 'bg' && __t('цените-за-подновяване-на-услугите-са-видими-в-клиe18d74')}
			  </div>
			  <div>
				  {__t("Всички цени са с включен 20% ДДС")}
			  </div>
		  </div>
	  </section>
	);
};

export default FooterDark;